import  * as schema from 'yup';
import { SimplePricingModel } from '../models/integrationSettings';

export const formSchema = schema.object<Partial<Record<keyof SimplePricingModel , schema.AnySchema>>>({
	price: schema.string().matches(/^-?((\d+(\.\d+)?))$/, 'Invalid value').length(10),
	currency: schema.string().length(3)
});